"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _errorCodes = _interopRequireDefault(require("../../utils/errorCodes"));
var _logCategoryActionLabel = _interopRequireDefault(require("../../loggers/logCategoryActionLabel"));
var _logging = require("../constants/logging");
var _default = exports["default"] = function _default(error, timeoutAction, statusAction, isInstreamLoggingEnabled) {
  if (!isInstreamLoggingEnabled) {
    return;
  }
  var msg = (0, _get["default"])(error, 'message', '');
  var code = (0, _get["default"])(error, 'code', '');
  var codeIndex = msg.indexOf('code');
  if (code === _errorCodes["default"].ECONNABORTED) {
    (0, _logCategoryActionLabel["default"])({
      action: timeoutAction
    });
  } else if (codeIndex >= 0) {
    var statusCode = msg.substring(codeIndex + 5);
    (0, _logCategoryActionLabel["default"])({
      action: "".concat(statusAction, ".").concat(statusCode)
    });
  } else {
    (0, _logCategoryActionLabel["default"])({
      action: _logging.actions.instreamRequestTrackingDataError
    }, {
      message: msg
    });
  }
};
//# sourceMappingURL=handleInstreamError.js.map